import axios from "axios";
export default {
	inject: ["openShowModalLoading", "closeShowModalLoading"],
	data() {
		return {
			isBusy: false,
			magazzinoArticoli: [],
			magazzinoArticoliRecordNumbers: 0,
			magazzinoArticoliPathResources: "/magazzinoarticoli",

			magazzinoArticoliGiacenzaItems: [],
			magazzinoArticoliGiacenzaRecordNumbers: 0,
			magazzinoArticoliGiacenzaPathResources: "/magazzinoarticoli/giacenze",

			magazzinoArticoliLottiItems: [],
			magazzinoArticoliLottiPathResources: "/magazzinoarticolilottiscadenze/giacenza",
			magazzinoArticoliLottiRecordNumbers: 0,


			magazzinoArticoliUnitaMisuraBaseOptions: [],
			magazzinoArticoliUnitaMisuraOptions: [],
			magazzinoArticoliUnitaMisuraPathResources: "/magazzinoarticolium",

			magazzinoMagazziniOptions: [],
			magazzinoMagazziniPathResources: "/magazzinomagazzini",

			magazzinoJsonData: {},
			articoliFields: [
				{ key: "index" },
				{
					key: "codiceArticolo",
					label: "Codice Articolo",
				},
				{
					key: "nomeArticolo",
					label: "Nome Articolo",
				},
				{
					key: "descrizioneArticolo",
					label: "Descrizione",
				},
				{
					key: "giacenza",
					label: "Giacenza",
				},
				{
					key: "categoria",
					label: "Categoria",
				},
				{
					key: "umId",
					label: "Multiplo",
				},
				{
					key: "matricoleLotti",
					label: "Gestione Matricole/Lotti",
				},
				{
					key: "actions",
					label: "",
				},
			],
		};
	},
	computed: {
		magazziniFisici() {
			return this.magazzinoMagazziniOptions.filter((e) => e.tipo === "FISICO");
		},
	},
	methods: {
		magazzinoArticoloLottiLoadResource(filtro) {
			let link = process.env.VUE_APP_PATH_API + this.magazzinoArticoliLottiPathResources;
			this.magazzinoArticoliLottiItems = [];
			axios.get(link, { params: filtro })
				.then((response) => {
					this.magazzinoArticoliLottiItems = response.data.data.list;
					this.magazzinoArticoliLottiRecordNumbers = response.data.data.recordsNumber;
				})
				.catch((error) => {
					this.$bvToast.toast("Errore nel caricamento dati: " + error.message, {
						title: "",
						variant: "danger",
						solid: true,
					});
				});
		},

		magazzinoArticoloMatricoleLoadResource(filtro) {
			let link = process.env.VUE_APP_PATH_API + this.magazzinoArticoliMatricolePathResources;
			this.magazzinoArticoliMatricoleItems = [];
			axios.get(link, { params: filtro })
				.then((response) => {
					this.magazzinoArticoliMatricoleItems = response.data.data;
				})
				.catch((error) => {
					this.$bvToast.toast("Errore nel caricamento dati: " + error.message, {
						title: "",
						variant: "danger",
						solid: true,
					});
				});
		},
		magazzinoArticoloMatricoleLoadResourceCallBack(filtro, callback) {
			let link = process.env.VUE_APP_PATH_API + this.magazzinoArticoliMatricolePathResources;
			this.magazzinoArticoliMatricoleItems = [];
			axios.get(link, { params: filtro })
				.then((response) => {
					this.magazzinoArticoliMatricoleItems = response.data.data;
					callback(response.data.data);
				})
				.catch((error) => {
					this.$bvToast.toast("Errore nel caricamento dati: " + error.message, {
						title: "",
						variant: "danger",
						solid: true,
					});
				});
		},

		magazzinoMagazziniLoadData(filtro) {
			let link = process.env.VUE_APP_PATH_API + this.magazzinoMagazziniPathResources;
			this.magazzinoMagazziniOptions = [];
			axios.get(link, { params: filtro })
				.then((response) => {
					this.magazzinoMagazziniOptions = response.data.data.list;
				})
				.catch((error) => {
					this.$bvToast.toast("Errore nel salvarei dati: " + error.message, {
						title: "",
						variant: "danger",
						solid: true,
					});
				});
		},

		magazzinoByCodiceMagazzinoLoadData(codiceMagazzino, codiceStruttura, callbacksuccess, callbackerror = null) {
			let link = process.env.VUE_APP_PATH_API + this.magazzinoMagazziniPathResources + "/" + codiceMagazzino;
			this.magazzinoJsonData = {};
			axios.get(link, { params: { codiceStruttura: codiceStruttura } })
				.then((response) => {
					this.magazzinoJsonData = response.data.data;
					callbacksuccess(response.data.data);
				})
				.catch((error) => {
					if (callbackerror) {
						callbackerror(error);
					} else {
						this.$bvToast.toast("Errore nel recupero dati: " + error.message, {
							title: "",
							variant: "danger",
							solid: true,
						});
					}
				});
		},

		magazzinoArticoliGiacenzeLoadData(filtro) {
			let link = process.env.VUE_APP_PATH_API + this.magazzinoArticoliGiacenzaPathResources;
			this.magazzinoArticoli = [];
			this.openShowModalLoading();
			axios.get(link, { params: filtro })
				.then((response) => {
					this.magazzinoArticoliGiacenzaItems = response.data.data.list;
					this.magazzinoArticoliGiacenzaRecordNumbers = response.data.data.recordsNumber;
					this.closeShowModalLoading();
				})
				.catch((error) => {
					this.closeShowModalLoading();
					this.$bvToast.toast("Errore nel caricare dati: " + error.message, {
						title: "",
						variant: "danger",
						solid: true,
					});
				});
		},

		magazzinoArticoliLoadData(filtro) {
			let link = process.env.VUE_APP_PATH_API + this.magazzinoArticoliPathResources;
			this.magazzinoArticoli = [];
			axios.get(link, { params: filtro })
				.then((response) => {
					this.magazzinoArticoliRecordNumbers = response.data.data.recordsNumber;
					this.magazzinoArticoli = response.data.data.list;
				})
				.catch((error) => {
					this.$bvToast.toast("Errore nel salvarei dati: " + error.message, {
						title: "",
						variant: "danger",
						solid: true,
					});
				});
		},

		mangazzinoArticoliUnitaMisuraLoadData() {
			let link = process.env.VUE_APP_PATH_API + this.magazzinoArticoliUnitaMisuraPathResources;
			this.magazzinoArticoliUnitaMisuraOptions = [];
			axios.get(link)
				.then((response) => {
					this.magazzinoArticoliUnitaMisuraOptions = response.data.data.list;
					this.magazzinoArticoliUnitaMisuraBaseOptions = response.data.data.list.filter(e => e.multiplo == 1);
				})
				.catch((error) => {
					this.$bvToast.toast("Errore nel salvarei dati: " + error.message, {
						title: "",
						variant: "danger",
						solid: true,
					});
				});
		},


	},
};
